import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=272e2fa8&"
import script from "./Hotels.vue?vue&type=script&lang=ts&"
export * from "./Hotels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports